import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { selectedEndDateAtom, selectedGameRangeAtom, selectedStartDateAtom } from '@/atoms/filters/highLevel';
import { GAME_RANGE_FILTER_OPTIONS } from '@/consts/gameRange';
import { DatePicker } from '../input/DatePicker';

export const DateRangeSelector = () => {
  const { t } = useTranslation('filters');
  const [selectedStartDate, setSelectedStartDate] = useAtom(selectedStartDateAtom);
  const [selectedEndDate, setSelectedEndDate] = useAtom(selectedEndDateAtom);
  const [selectedGameRange, setSelectedGameRange] = useAtom(selectedGameRangeAtom);

  const handleDateChange = (date: string, isStartDate: boolean) => {
    const setDate = isStartDate ? setSelectedStartDate : setSelectedEndDate;
    setDate(date);
    // in order for start and end dates to save to a filter set correctly, the selectedGameRange must be set to 'dateRange'.
    // Data lockers only have 'dateRange', so we don't have a button to change the default mode from 'period' to 'dateRange' before a user
    // interacts with the date picker. Therefore, if a user interacts with the date range picker we assume they are on 'dateRange' mode.
    if (selectedGameRange.key !== 'dateRange') {
      setSelectedGameRange(GAME_RANGE_FILTER_OPTIONS[1]);
    }
  };

  return (
    <>
      <DatePicker
        label={t('startDate')}
        id="filter-start-date"
        value={selectedStartDate}
        onChange={date => handleDateChange(date, true)}
      />
      <DatePicker
        label={t('endDate')}
        id="filter-end-date"
        value={selectedEndDate}
        onChange={date => handleDateChange(date, false)}
      />
    </>
  );
};
